import { render } from "./SalesDashboard.vue?vue&type=template&id=7aadfc05&scoped=true"
import script from "./SalesDashboard.vue?vue&type=script&lang=js"
export * from "./SalesDashboard.vue?vue&type=script&lang=js"

import "./SalesDashboard.vue?vue&type=style&index=0&id=7aadfc05&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aadfc05"]])

export default __exports__